import { render, staticRenderFns } from "./cc-selector.vue?vue&type=template&id=4878d531&scoped=true"
import script from "./cc-selector.vue?vue&type=script&lang=ts"
export * from "./cc-selector.vue?vue&type=script&lang=ts"
import style0 from "./cc-selector.vue?vue&type=style&index=0&id=4878d531&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878d531",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4878d531')) {
      api.createRecord('4878d531', component.options)
    } else {
      api.reload('4878d531', component.options)
    }
    module.hot.accept("./cc-selector.vue?vue&type=template&id=4878d531&scoped=true", function () {
      api.rerender('4878d531', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/cc-selector/cc-selector.vue"
export default component.exports